/**
 * Ensures the returned object is an array
 * It will return the same object when the given object already is an array
 */
export function ensureArray<T>(object: T | T[]): T[] {
	return Array.isArray(object) ? object : [object];
}
